import { useHistory, useLocation } from 'react-router-dom'

export const useQueryParams = () => {
    const history = useHistory()
    const location = useLocation()

    const searchParams = new URLSearchParams(location.search)

    const setQueryParam = (key: string, value?: string) => {
        if (value === undefined) {
            searchParams.append(key, '')
            const searchString = searchParams.toString().replace(/=&/g, '&').replace(/=$/, '')
            history.replace({
                pathname: location.pathname,
                search: searchString
            })
        } else {
            searchParams.set(key, value)
            history.replace({
                pathname: location.pathname,
                search: searchParams.toString()
            })
        }
    }

    const removeQueryParam = (key: string) => {
        searchParams.delete(key)
        history.replace({
            pathname: location.pathname,
            search: searchParams.toString()
        })
    }

    const removeMenuParams = () => {
        const authParams = ['ageverif', 'login', 'register', 'activate', 'restore', 'passwordChange']

        authParams.forEach((param) => searchParams.delete(param))

        history.replace({ pathname: location.pathname, search: searchParams.toString() })
    }

    const hasQueryParam = (key: string) => {
        return searchParams.has(key)
    }

    const getQueryParam = (key: string): string | boolean | null => {
        if (!hasQueryParam(key)) return null
        const value = searchParams.get(key)
        return value === '' ? true : value
    }

    const getAllQueryParams = () => {
        //@ts-ignore
        return Object.fromEntries(searchParams.entries())
    }

    const hasAnyQueryParam = (keys: string[]): boolean => {
        //@ts-ignore
        return keys.some((key) => searchParams.has(key))
    }

    return {
        setQueryParam,
        removeQueryParam,
        removeMenuParams,
        getQueryParam,
        getAllQueryParams,
        hasAnyQueryParam
    }
}
